import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { color } from "chart.js/helpers";
import { size } from "underscore";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const MultipleAxisBarChart = (props) => {
  const { data, label, tooltip, text1, text2, xText } = props;

  // Sample data structure:
  // data = [
  //   { label: "Sales", data: [100, 200], backgroundColor: "blue", yAxisID: "y" },
  //   { label: "Profit", data: [10, 20], backgroundColor: "green", yAxisID: "y1" }
  // ]

  const chartData = {
    labels: label,
    datasets: data,
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { position: "bottom", display: true },
      title: { display: false },
      tooltip: tooltip,
    },
    scales: {
      x: {
        stacked: false,
        grid: { display: false },
        title: {
          display: true,
          text: xText,
          font: { weight: "bold", color: "black", size: 16 },
        },
      },
      y: {
        type: "linear",
        display: true,
        position: "left",
        title: {
          display: true,
          text: text1,
        },
      },
      y1: {
        type: "linear",
        display: true,
        position: "right",
        grid: {
          drawOnChartArea: false, // Only show grid for left y-axis
        },
        title: {
          display: true,
          text: text2,
        },
      },
    },
    barPercentage: 0.8,
    categoryPercentage: 0.9,
  };

  return <Bar data={chartData} options={options} />;
};

export default MultipleAxisBarChart;
